module.exports = __webpack_public_path__ + "img/81.8.TSS.e158d734.png";